import styled from 'styled-components';
import { prop } from 'ramda';
import { smallSpacedHeading, paragraph } from '../../../theme/typography';

export const Container = styled.div``;

export const Title = styled.h1`
  ${smallSpacedHeading}
  margin: 0;
  text-align: left;
`;

export const Content = styled.div`
  ${paragraph}

  margin-top: 32px;
  ${prop('extraStyles')}
`;
